<template>
  <el-container class="container">
    <el-main class="flex flex1 flex-column main">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-position="right"
               label-width="110px">
        <el-form-item label="项目" prop="projectId">
          <options-select
              v-model="queryParams.projectId"
              @change="projectChange"
              :options="projectOptions"
              placeholder="请选择项目"
              size="small"
              clearable
          />
        </el-form-item>
      </el-form>

      <div v-if="!hasModules" class="guide-container">
        <el-steps :active="currentStep" finish-status="success" class="guide-steps">
          <el-step title="选择项目"></el-step>
          <el-step title="选择本地路径"></el-step>
          <el-step title="扫描 pom.xml"></el-step>
          <el-step title="勾选录入"></el-step>
        </el-steps>

        <div class="step-content">
          <div v-if="currentStep === 0" class="step-panel">
            <div class="step-title">请选择一个项目</div>
            <div class="step-desc">选择要关联的项目，后续扫描到的模块将录入到该项目下</div>
            <el-button type="primary" @click="goToStep(1)" :disabled="!queryParams.projectId">下一步</el-button>
          </div>

          <div v-if="currentStep === 1" class="step-panel">
            <div class="step-title">选择本地项目路径</div>
            <div class="step-desc">请选择包含 pom.xml 的本地项目根目录</div>
            <el-button type="primary" @click="selectDirectory">选择目录</el-button>
            <div v-if="selectedPath" class="selected-path">
              <i class="el-icon-folder-opened"></i>
              {{ selectedPath }}
            </div>
            <div class="step-buttons">
              <el-button @click="goToStep(0)">上一步</el-button>
              <el-button type="primary" @click="goToStep(2)" :disabled="!selectedPath">下一步</el-button>
            </div>
          </div>

          <div v-if="currentStep === 2" class="step-panel">
            <div class="step-title">扫描 pom.xml 文件</div>
            <div class="step-desc">点击扫描按钮，系统将递归查找并解析 pom.xml 中的模块</div>
            <el-button type="primary" @click="scanPomXml" :loading="scanning">扫描</el-button>
            <div v-if="scannedModules.length > 0" class="scan-result">
              <div class="scan-result-title">扫描到 {{ scannedModules.length }} 个模块：</div>
              <div class="module-tags">
                <el-tag v-for="(module, index) in scannedModules" :key="index" style="margin: 5px;">
                  {{ module }}
                </el-tag>
              </div>
            </div>
            <div class="step-buttons">
              <el-button @click="goToStep(1)">上一步</el-button>
              <el-button type="primary" @click="goToStep(3)" :disabled="scannedModules.length === 0">下一步</el-button>
            </div>
          </div>

          <div v-if="currentStep === 3" class="step-panel">
            <div class="step-title">勾选要录入的模块</div>
            <div class="step-desc">选择要录入到数据库的模块，name 和 code 都将使用模块名</div>
            <el-table :data="scannedModuleRows" style="width: 100%; margin-top: 15px;" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="模块名" prop="name"></el-table-column>
              <el-table-column label="模块编码" prop="code"></el-table-column>
            </el-table>
            <div class="step-buttons">
              <el-button @click="goToStep(2)">上一步</el-button>
              <el-button type="primary" @click="submitModules" :loading="submitting" :disabled="selectedModules.length === 0">
                录入
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="modules-container">
        <div class="modules-grid">
          <div v-for="module in modules" :key="module.id" class="module-card">
            <div class="module-name">{{ module.name }}</div>
            <div class="module-code">{{ module.code }}</div>
          </div>
        </div>
      </div>
    </el-main>
    <div style="width: 10px;"></div>
    <el-aside class="aside" width="372px">
      <div style="font-size: medium;font-weight: bolder;text-align: center;margin: 15px 10px 0;">智慧功能</div>
      <AICreateTableButton class="function_btn" style="margin: 0; margin-top: 15px;">智能建表</AICreateTableButton>
      <AICreateCodeButton class="function_btn" style="margin: 0; margin-top: 15px;">智能生成代码</AICreateCodeButton>
      <el-button type="warning" plain class="function_btn">便捷开发</el-button>
      <el-button type="success" plain class="function_btn">人脸SDK集成项目下载</el-button>
      <el-button type="primary" plain class="function_btn">查看模块详情</el-button>
    </el-aside>
  </el-container>
</template>

<script>
import AICreateTableButton from "@/views/data/workSpace/components/AICreateTableButton.vue";
import AICreateCodeButton from "@/views/data/workSpace/components/AICreateCodeButton.vue";
import { getProjectList, getModuleListByProjectId, createModule } from "@/api/dataApi";

export default {
  components: {
    AICreateTableButton,
    AICreateCodeButton
  },
  name: "WorkSpace",
  data() {
    return {
      queryParams: {
        projectId: null
      },
      projectOptions: [],
      modules: [],
      hasModules: false,
      currentStep: 0,
      selectedPath: '',
      scannedModules: [],
      selectedModules: [],
      scanning: false,
      submitting: false,
      directoryHandle: null
    }
  },
  created() {
    this.initData();
  },
  computed: {
    scannedModuleRows() {
      return this.scannedModules.map(name => ({ name, code: name }));
    }
  },
  methods: {
    async initData() {
      try {
        const res = await getProjectList();
        if (res.data && res.data.length > 0) {
          this.projectOptions = res.data;
          this.queryParams.projectId = res.data[0].id;
          await this.loadModules();
        }
      } catch (error) {
        console.error('初始化数据失败:', error);
      }
    },
    async loadModules() {
      if (!this.queryParams.projectId) {
        this.modules = [];
        this.hasModules = false;
        return;
      }
      try {
        const res = await getModuleListByProjectId(this.queryParams.projectId);
        this.modules = res.data || [];
        this.hasModules = this.modules.length > 0;
      } catch (error) {
        console.error('加载模块列表失败:', error);
        this.modules = [];
        this.hasModules = false;
      }
    },
    async projectChange() {
      await this.loadModules();
      if (!this.hasModules) {
        this.currentStep = 0;
        this.selectedPath = '';
        this.scannedModules = [];
        this.selectedModules = [];
      }
    },
    goToStep(step) {
      this.currentStep = step;
    },
    async selectDirectory() {
      try {
        if (!window.showDirectoryPicker) {
          this.$message.error('当前浏览器不支持 File System Access API，请使用 Chrome 86+ 或 Edge 86+');
          return;
        }
        this.directoryHandle = await window.showDirectoryPicker();
        this.selectedPath = this.directoryHandle.name;
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('选择目录失败:', error);
          this.$message.error('选择目录失败');
        }
      }
    },
    async scanPomXml() {
      if (!this.directoryHandle) {
        this.$message.warning('请先选择目录');
        return;
      }
      this.scanning = true;
      this.scannedModules = [];
      try {
        await this.findAndParsePomXml(this.directoryHandle);
        if (this.scannedModules.length === 0) {
          this.$message.info('未找到任何模块');
        } else {
          this.$message.success(`扫描完成，找到 ${this.scannedModules.length} 个模块`);
        }
      } catch (error) {
        console.error('扫描失败:', error);
        this.$message.error('扫描失败');
      } finally {
        this.scanning = false;
      }
    },
    async findAndParsePomXml(dirHandle) {
      try {
        for await (const [name, handle] of dirHandle.entries()) {
          if (handle.kind === 'file' && name === 'pom.xml') {
            const file = await handle.getFile();
            const text = await file.text();
            const modules = this.parseModulesFromPom(text);
            modules.forEach(m => {
              if (!this.scannedModules.includes(m)) {
                this.scannedModules.push(m);
              }
            });
          } else if (handle.kind === 'directory') {
            await this.findAndParsePomXml(handle);
          }
        }
      } catch (error) {
        console.error('遍历目录出错:', error);
      }
    },
    parseModulesFromPom(pomContent) {
      const modules = [];
      const moduleRegex = /<module>([^<]+)<\/module>/g;
      let match;
      while ((match = moduleRegex.exec(pomContent)) !== null) {
        const moduleName = match[1].trim();
        if (moduleName) {
          modules.push(moduleName);
        }
      }
      return modules;
    },
    handleSelectionChange(selection) {
      this.selectedModules = selection;
    },
    async submitModules() {
      if (this.selectedModules.length === 0) {
        this.$message.warning('请至少选择一个模块');
        return;
      }
      this.submitting = true;
      try {
        for (const moduleRow of this.selectedModules) {
          await createModule({
            name: moduleRow.name,
            code: moduleRow.code,
            projectId: this.queryParams.projectId
          });
        }
        this.$message.success('录入成功');
        await this.loadModules();
      } catch (error) {
        console.error('录入失败:', error);
        this.$message.error('录入失败');
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    height: 100%;
    border-radius: 8px;
    .main {
      height: 100%;
      align-content: flex-start;
      overflow:auto;
      border: solid #dcdfe6 1px;
      border-radius: 8px;
      padding-left: 2px;
      padding-top: 15px;
      padding-bottom: 8px;
      background: #F1F5FB;

      .guide-container {
        padding: 20px;
        .guide-steps {
          margin-bottom: 40px;
        }
        .step-content {
          background: white;
          border-radius: 8px;
          padding: 30px;
          border: solid #dcdfe6 1px;
          .step-panel {
            text-align: center;
            .step-title {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .step-desc {
              color: #909399;
              margin-bottom: 20px;
            }
            .selected-path {
              margin-top: 15px;
              padding: 10px 15px;
              background: #f5f7fa;
              border-radius: 4px;
              display: inline-block;
              i {
                margin-right: 8px;
                color: #409eff;
              }
            }
            .scan-result {
              margin-top: 20px;
              text-align: left;
              .scan-result-title {
                margin-bottom: 10px;
                font-weight: bold;
              }
              .module-tags {
                display: flex;
                flex-wrap: wrap;
              }
            }
            .step-buttons {
              margin-top: 30px;
            }
          }
        }
      }

      .modules-container {
        padding: 0 10px;
        .modules-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 15px;
        }
        .module-card {
          background: white;
          border: solid #dcdfe6 1px;
          border-radius: 8px;
          padding: 20px;
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          }
          .module-name {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 8px;
          }
          .module-code {
            font-size: 12px;
            color: #909399;
          }
        }
      }
    }
    .aside {
      background: #F1F5FB;
      border-radius: 8px;
      border: solid #dcdfe6 1px;
      padding: 10px 10px 8px;
      .function_btn {
        width: 100%;
        margin-top: 15px;
        margin-left: 0;
      }
    }
  }
</style>
